<template>
  <div class="ui-tip-dot" :data-placement="placement"></div>
</template>

<script setup>
defineProps({
  // 'label' 相对 .label-box 右上角 (文本类: nav-bar 大页签 / multi tab 小页签)
  // 'button' 相对纯图标按钮容器 (live-room 三按钮)
  placement: {
    type: String,
    default: () => 'label',
    validator: (v) => ['label', 'button'].includes(v)
  }
})
</script>

<style lang="scss" scoped>
.ui-tip-dot {
  position: absolute;
  @include r(width, 12);
  @include r(height, 12);
  background-color: #FFB62D;
  border-radius: 50%;
  border: 1px solid #fff;

  // 文本右上角: 消费端挪进 .label-box (全局 position: relative), 红点浮出 label 右上一点
  &[data-placement='label'] {
    @include r(top, 4);
    @include r(right, -24);
  }

  // 纯图标按钮内右上角
  &[data-placement='button'] {
    top: 13%;
    right: 8%;
  }
}
</style>
